<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form @keyup.enter="load">
                    <b-row>
                        <b-col lg="4" sm="12" class="text-left">
                            <LgFinderPageTipoContrato @input="setTipo" :prefix="prefix + title + ' > '"
                                v-model="tipoSelecionado" label="Tipo de Contrato:" />
                        </b-col>
                        <b-col lg="4" sm="12" class="text-left">
                            <lg-form-const-select label="Situação:" v-model="situacaoSelecionada"
                                :options="opcoesSituacao" @change="load" />
                        </b-col>
                        <b-col lg="4" md="4" sm="12" class="btn-size-alinhamento">


                            <b-button id="limpar-contratos" class="my-2" size="sm" style="height: 20px" pill
                                variant="primary" @click="clearForm">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="eraser" />
                                </div>
                                <b-tooltip target="limpar-contratos" title="Limpar"></b-tooltip>
                            </b-button>

                            <b-button id="localizar-contratos" class="ml-3 mr-2 my-2" size="sm" style="height: 20px"
                                pill variant="primary" @click="load">
                                <div class="btn-size-alinhamento">
                                    <b-icon icon="search" />
                                </div>
                                <b-tooltip target="localizar-contratos" title="Localizar"></b-tooltip>
                            </b-button>


                            <b-button id="novo" class="ml-3 mr-2 my-2" style="height: 20px" @click="abrirNovo" size="sm"
                                pill variant="secondary">
                                <div class="btn-size-alinhamento">
                                    <b-icon scale="1" icon="plus" />
                                </div>
                                <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>
                            </b-button>


                        </b-col>
                    </b-row>
                </b-form>
            </b-card>
            <b-card bg-variant="light" class="mt-3">
                <b-table responsive class="mt-2" small :busy="busy" :items="records" @row-dblclicked="contratoSelected"
                    :fields="fields" hover show-empty>

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(vigencias)="data">
                        <span v-if="data.item.dataInicial && data.item.dataFinal">
                            {{ formatDate(data.item.dataInicial) }} -
                            {{ formatDate(data.item.dataFinal) }}
                        </span>
                        <span v-else>
                            N/A
                        </span>
                    </template>
                    <template v-slot:cell(situacaoContrato)="data">

                        <b-badge :variant="badgeVariant(data.item.situacaoContrato)" class="badge">
                            {{ formatSituacao(data.item.situacaoContrato) }}
                        </b-badge>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-row>
                            <b-button v-if="data.item.situacaoContrato == 'VIGENTE'" class="my-2 mx-1" size="sm" pill
                                variant="primary"
                                @click="abrirRegistroEntradaForm(data.item.totalItens != data.item.totalItensEntrada, data.item)">
                                <b-icon v-b-tooltip.hover.top="'Registro de Entrada'"  icon="file-earmark-plus" />
                            </b-button>

                            <b-button :id="data.index + 'edit-button'" class="my-2" size="sm" pill variant="primary"
                                @click="editarContrato(data.item)">
                                <b-icon icon="pencil-square" />
                            </b-button>
                            <b-button :id="data.index + 'delete-button'" class="my-2" size="sm" pill variant="danger"
                                @click="excluirContrato(data.item)">
                                <b-icon icon="trash" />
                            </b-button>
                        </b-row>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <ContratoForm :id="id" :idFinderContrato="idFinderContrato" :processoCompra="processoCompra" v-if="showForm"
            :prefix="prefix + title + ' > '" @close="fecharModal"></ContratoForm>

        <ModalRegistroEntradaList :podeAdicionarRegistro="podeAdicionarRegistro" v-if="showModalRegistroEntradaList"
            :prefix="prefix + title" ref="modalRegistroEntradaForm" @close="fecharRegistroEntradaForm"
            :contrato='selectedContrato' />

    </b-card>
</template>

<script>
import LgFinderPageTipoContrato from "@/components/Finders/LgFinderPageTipoContrato.vue"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import ContratoForm from "./ContratoForm.vue"
import ResourceService from "@/core/api/ResourceService";
import { ListResourceMixin } from "@/core/mixins/resource"
import ConfirmMixin from "@/core/mixins/confirm"
import ModalRegistroEntradaList from "@/modules/almoxarifados/registros-entrada/ModalRegistroEntradaList.vue";

export default {
    components: {
        LgFinderPageTipoContrato,
        LgFormConstSelect,
        ContratoForm,
        ModalRegistroEntradaList
    },
    props: {
        idFinderContrato: {
            type: String,
            default: "",
        },
        processoCompra: {
            type: Object,
            default: null
        },

        prefix: {
            type: String,
            default: "",
        },
        objeto: {
            type: String,
            default: null
        },


    },

    mixins: [ListResourceMixin, ConfirmMixin],

    data() {
        return {
            podeAdicionarRegistro: false,
            showModalRegistroEntradaList: false,
            title: "Consultar Contratos",
            id: null,
            showForm: false,
            fields: [
                { key: "numeroContrato", label: "Nº do Contrato" },
                { key: "vigencias", label: "Última vigência" },
                {
                    key: "departamentoDescricao",
                    label: "Departamento",
                    formatter: (value) => value || "N/A",
                },
                { key: "objeto", label: "Objeto" },
                { key: "situacaoContrato", label: "Status" },
                { key: "totalItens", label: "Total Itens" },
                { key: "totalItensEntrada", label: "Consumo" },

                { key: "actions", label: " " },
            ],
            estadoSelecionado: null,
            situacaoSelecionada: null,
            tipoSelecionado: null,
            contratadaSelecionada: null,
            busy: false,
            perpage: 10,
            perPageOptions: [10, 25, 50, 100],
            opcoesSituacao: [
                { value: null, text: "Todas" },
                { value: "VIGENTE", text: "Vigente" },
                { value: "EXPIRADO", text: "Expirado" },
                { value: "ENCERRADO", text: "Encerrado" },
                { value: "NAO_INICIADO", text: "Não Iniciado" },
            ],
        };
    },
    watch: {
        page() {
            this.load()
        },
    },
    beforeMount() {
        this.$service = new ResourceService("/api/contratos");
        this.load();
    },
    methods: {
        abrirRegistroEntradaForm(podeAdicionarRegistro, contrato) {
            this.podeAdicionarRegistro = podeAdicionarRegistro;
            this.selectedContrato = contrato;
            this.showModalRegistroEntradaList = true;

        },
        fecharRegistroEntradaForm() {
            this.podeAdicionarRegistro = true;
            this.showModalRegistroEntradaList = false;
            this.selectedAutorizacaoId = null
            this.load();
        },


        setTipo(item) {
            this.tipoSelecionado = item;
            this.load();
        },
        async load() {
            this.busy = true;
            this.filtro = {};

            if(this.processoCompra != null){
                this.filtro.processoCompra = this.processoCompra.id;
            }

            if (this.objeto && this.objeto != "")
                this.filtro.objeto = this.objeto;

            if (this.tipoSelecionado && this.tipoSelecionado.id) {
                this.filtro.tipoContratoId = this.tipoSelecionado.id;
            }

            if (this.situacaoSelecionada) {
                this.filtro.situacao = this.situacaoSelecionada;
            }

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            })

        },
        editarContrato(contrato) {
            this.id = contrato.id;
            this.showForm = true;
        },
        async excluirContrato(item) {
            await this.$removeResource(item);

        },
        fecharModal() {
            this.showForm = false;
            this.id = null;
            this.load()
        },
        abrirNovo() {
            this.showForm = true;
        },
        clearForm() {
            this.estadoSelecionado = null;
            this.situacaoSelecionada = null;
            this.tipoSelecionado = null;
            this.contratadaSelecionada = null;
            this.currentPage = 1;
            this.load();
        },
        formatDate(dateString) {
            if (!dateString) return "N/A";
            const [year, month, day] = dateString.split("-");
            return `${day}/${month}/${year}`;
        },
        formatSituacao(situacao) {
            const situacoes = {
                VIGENTE: "Vigente",
                EXPIRADO: "Expirado",
                ENCERRADO: "Encerrado",
                NAO_INICIADO: "Não Iniciado",
            };
            return situacoes[situacao] || "N/A";
        },
        contratoSelected(contrato) {
            this.$emit("onDblClickContrato", contrato);
        },
        badgeVariant(situacao) {
            const variants = {
                VIGENTE: "success",
                EXPIRADO: "danger",
                ENCERRADO: "warning",
                NAO_INICIADO: "secondary",
            };
            return variants[situacao] || "secondary";
        },
    },
};
</script>

<style scoped>
.badge {
    font-size: 85% !important;
    padding: 5px 10px !important;
}

.btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
